<template>
  <div class="wrapper">
    <h1 ref="title" class="split-title m-d">{{ content.title }}</h1>
    <hr />
    <div class="row">
      <div class="col-xxxs-12 col-xl-8 col-xl-offset-3">
        <div
          v-for="(cpt, i) in content.flexibleContent"
          :key="i"
          :class="cptClass(cpt.component as string) || defaultClasses"
        >
          <component
            :is="component[cpt.component as keyof typeof flexibleComponentList]"
            v-if="
              component[cpt.component as keyof typeof flexibleComponentList] &&
              cpt.content
            "
            :content="cpt.content"
          />
        </div>
      </div>
    </div>

    <hr />
    <UiCta :content="content.cta" class="m-d" />
  </div>
</template>

<script setup lang="ts">
import { PropType, onMounted, ref, onBeforeUnmount } from 'vue'

import { Content } from '@/types/views/default'

import UiCta from '@/components/ui/Cta.vue'

import { SplitTitle, createSplitTitle } from '@/animations/splitTitle'
import flexibleComponentList from '@/modules/flexibleComponentList'

defineProps({
  content: {
    type: Object as PropType<Content>,
    required: true,
  },
})

let splitTitle: SplitTitle
const title = ref({} as HTMLElement)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const component = flexibleComponentList()

const cptClass = (name: string) => {
  const classes: Record<string, string[]> = {
    wysiwyg: ['fc-wysiwyg', 'm-d'],
  }

  return classes[name]
}

const defaultClasses = ['m-d']

onMounted(() => {
  splitTitle = createSplitTitle(title.value)
  splitTitle.intro.play()
})

onBeforeUnmount(async () => {
  await splitTitle.outro.play().then()
})
</script>

<style lang="scss" scoped>
.fc-wysiwyg {
  :deep(.wysiwyg:not(.wrapper)) {
    width: 100%;
  }
}
</style>
